<template>
  <div class="moneyDetail">
    <div style="display:flex;height:32px;align-items: center;">
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='DAY'?'active':''"
        type="text"
        @click="chooseType('DAY')"
      >今日</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='MONTH'?'active':''"
        type="text"
        @click="chooseType('MONTH')"
      >本月</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='YEAR'?'active':''"
        type="text"
        @click="chooseType('YEAR')"
      >本年</el-button>
      <el-form ref="form" :model="form" inline>
        <el-form-item label="自定义时间">
          <el-date-picker
            v-model="form.date1"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            size="small"
            style="width: 150px;"
          />
          &nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;
          <el-date-picker
            v-model="form.date2"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 150px;"
          />
        </el-form-item>
        <el-form-item style="margin-left:30px">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" plain @click="backFn">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="box">
      <ul>
        <li><span>企业名称:</span><span>{{ orgDetail.name }}</span></li>
        <li><span>组织机构代码:</span><span>{{ orgDetail.code }}</span></li>
        <li><span>联系人:</span><span>{{ orgDetail.contactUser }}</span></li>
        <li><span>电话:</span><span>{{ orgDetail.contactNum }}</span></li>
        <li><span>邮箱:</span><span>{{ orgDetail.email }}</span></li>
      </ul>
      <div class="content" style="position:relative">
        <div
          class="gang1"
          style="width:6px;height:109px;background:rgb(204, 204, 204);position:absolute;left:20%"
        />
        <div
          class="gang2"
          style="width:6px;height:109px;background:rgb(204, 204, 204);position:absolute;left:40%"
        />
        <div
          class="gang3"
          style="width:6px;height:109px;background:rgb(204, 204, 204);position:absolute;left:60%"
        />
        <div style="width:20%;display:flex;flex-direction: column;align-items:center">
          <div style="display:flex;align-items: center;">
            <i class="iconfont icon-iconset0216" style="font-size:54px;display:block" />
            <div style="font-size:18px;color:#333333;margin-bottom:10px;padding-left:15px">充电度数</div>
          </div>
          <div style="margin-top:10px;margin-left:10px">
            <span
              class="moneyNum"
              :title="detail.power"
            >{{ getFloat(detail.power) }}</span>
            <span style="font-size:14px;color:#333333;">度</span>
          </div>
        </div>
        <div style="width:20%;display:flex;flex-direction: column;align-items:center">
          <div style="display:flex;align-items: center;">
            <img src="./../../assets/icon2.png" alt="" style="width:54px;height:54px">
            <span
              style="font-size:18px;color:#333333;margin-bottom:10px;display:block;padding-left:15px"
            >实收电费</span>
          </div>
          <div style="margin-top:10px;margin-left:10px">
            <span
              class="moneyNum"
              :title="detail.elecMoney"
            >{{ getFixed2(detail.elecMoney) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:20%;display:flex;flex-direction: column;align-items:center">
          <div style="display:flex;align-items: center;">
            <img src="./../../assets/icon3.png" alt="" style="width:54px;height:54px">
            <span
              style="font-size:18px;color:#333333;margin-bottom:10px;display:block;padding-left:15px"
            >实收服务费</span>
          </div>
          <div style="margin-top:10px;margin-left:10px">
            <span
              class="moneyNum"
              :title="detail.serviceMoney"
            >{{ getFixed2(detail.serviceMoney) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:40%;display:flex;justify-content: center;">
          <div>
            <img src="./../../assets/icon4.png" alt="" style="width:100px;height:97px">
          </div>
          <div>
            <div style="margin-left:10px">
              <span
                style="font-size:18px;color:#333333;margin-bottom:15px;display:inline-block;margin-left:15px;margin-right:40px"
              >运营商分润</span>
              <span
                class="moneyNum"
                :title="detail.operatorProfit"
              >{{ getFloat(detail.operatorProfit) }}</span>
              <span style="font-size:14px;color:#333333;">元</span>
            </div>
            <div style="margin-left:10px">
              <span
                style="font-size:18px;display:inline-block;margin-left:15px;margin-right:40px"
              >其他方分润</span>
              <span
                class="moneyNum"
                :title="detail.otherProfit"
              >{{ getFloat(detail.otherProfit) }}</span>
              <span style="font-size:14px;color:#333333;">元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="main" style="position:relative">
        <el-button type="primary" style="position:absolute;right:40px;top:20px;z-index:100" @click="exportOrder">导出</el-button>
        <el-card>
          <el-tabs v-model="activeName" @tab-click="onSubmit">
            <el-tab-pane label="分润方" name="TARGET" />
            <el-tab-pane label="电站" name="STATION" />
          </el-tabs>
          <template v-if="activeName == 'TARGET'">
            <el-table :data="tableData" stripe border style="width: 100%">
              <el-table-column type="index" align="center" width="50" label="序号" />
              <el-table-column label="分润方账号" align="center">
                <template slot-scope="scope">
                  {{ scope.row.targetLoginName }}
                </template>
              </el-table-column>
              <el-table-column label="分润方姓名" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.targetUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="充电度数" align="center">
                <template slot-scope="scope">
                  <span>{{ getFloat(scope.row.power) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实收电费" align="center">
                <template slot-scope="scope">
                  <span>{{ getFixed2(scope.row.elecMoney) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实收服务费" align="center">
                <template slot-scope="scope">
                  <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="分润金额" align="center">
                <template slot-scope="scope">
                  <span>{{ getFloat(scope.row.amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="jumpFn(scope.row)">订单明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-if="activeName == 'STATION'">
            <el-table :data="tableData" stripe border style="width: 100%">
              <el-table-column type="index" align="center" width="50" label="序号" />
              <el-table-column label="电站名称" align="center">
                <template slot-scope="scope">
                  {{ scope.row.stationName }}
                </template>
              </el-table-column>
              <el-table-column label="充电度数" align="center">
                <template slot-scope="scope">
                  <span>{{ getFloat(scope.row.power) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实收电费" align="center">
                <template slot-scope="scope">
                  <span>{{ getFixed2(scope.row.elecMoney) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实收服务费" align="center">
                <template slot-scope="scope">
                  <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="分润模式" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.mode=='PERCENT'?'固定折扣':'固定价格' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="运营商分润金额" align="center">
                <template slot-scope="scope">
                  <span>{{ getFloat(scope.row.operatorProfit) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="其他方分润金额" align="center">
                <template slot-scope="scope">
                  <span>{{ getFloat(scope.row.otherProfit) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="jumpFn(scope.row)">订单明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>

        </el-card>
      </div>
    </div>
    <el-pagination
      v-if="pageshow"
      style="margin-top:20px"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'Fenrunmingxi',
  components: {},
  data() {
    return {
      orgId: '',
      form: {
        date1: '',
        date2: ''
      },
      timeType: 'DAY',
      activeName: 'TARGET',
      orgDetail: {},
      detail: {},
      tableData: [],
      currentPage: 1, // 当前页
      total: 100, // 总页数
      pagesize: 10, // 每页条数
      pageshow: true
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getPageData()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.orgId = this.$route.query.id
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    jumpFn(row) {
      const query = {
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2
      }
      if (this.activeName === 'TARGET') {
        query.targetId = row.targetId
        query.targetName = row.targetName || row.targetUserName
      } else {
        query.stationId = row.stationId
        query.stationName = row.stationName
      }
      this.$router.push({
        path: './payDetail',
        query: query
      })
    },
    backFn() {
      this.$router.push('/ticketManagement/moneyCount')
    },
    chooseType(val) {
      this.timeType = val
      this.form = {
        date1: '',
        date2: ''
      }
    },
    onSubmit() {
      this.getPageData()
    },
    handleSizeChange(val) {
      this.pageshow = false
      this.pagesize = val
      this.tableData = []
      this.getPageData()
    },

    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.tableData = []
      this.getPageData()
    },

    getPageData() {
      const data = {
        orgId: this.orgId,
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2,
        groupBy: this.activeName
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/detail',
        data: data,
        method: 'get',
        callback: resp => {
          this.detail = resp.summary
          this.orgDetail = resp.org
          if (resp.list && resp.list.length > 0) {
            this.tableData = resp.list
            this.pageshow = true
          } else {
            this.pageshow = false
            this.tableData = []
          }
          this.currentPage = resp.pageNo
          this.total = resp.count
          this.pagesize = resp.pageSize
        }
      })
    },
    exportOrder() {
      const url = HOST + '/finance/profit/detail/export'
      $.fileDownload(url, {
        httpMethod: 'get',
        data: {
          orgId: this.orgId,
          pageNo: this.currentPage,
          pageSize: this.pagesize,
          timeType: this.timeType,
          startTime: this.form.date1,
          endTime: this.form.date2,
          groupBy: this.activeName,
          token: window.localStorage.getItem('token')
        },
        failCallback: (html, url) => {
          this.$notify({
            title: '失败',
            message: '导出失败',
            type: 'error'
          })
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" scoped>
    .moneyDetail {
        .textType {
            color: #C0C4CC;
            width: 100px;

            &.active {
                color: #409eff;
                border-bottom: 2px solid #409eff;
            }
        }

        .box {
            height: 226px;
            display: flex;
            margin-top: 20px;
            margin-bottom: 40px;
            padding: 0;

            ul {
                width: 23%;
                height: 100%;
                border: 1px solid rgb(121, 121, 121);
                padding: 0;
                margin: 0;

                li {
                    list-style: none;
                    height: 20%;
                    display: flex;
                    align-items: center;
                    position: relative;

                    span {
                        display: inline-block;

                        &:nth-of-type(1) {
                            padding-left: 20px;
                        }

                        &:nth-of-type(2) {
                            display: block;
                            position: absolute;
                            left: 150px;
                        }
                    }
                }
            }

            .content {
                width: 74%;
                height: 100%;
                border: 1px solid rgb(121, 121, 121);
                display: flex;
                align-items: center;
            }

            .moneyNum {
                font-size: 31px;
                color: #1890FF;
                font-weight: 500;
                max-width: calc(100% - 20px);
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            div {
                .iconfont {
                    font-size: 28px;
                    font-weight: 600;
                }

                .icon-iconset0216 {
                    color: #32F83E;
                }

                .icon-lirunbiao {
                    color: #F2E743;
                }

                .icon-yingshouzhangkuan {
                    color: #F2E743;
                    font-size: 24px;
                }

                .icon-qianbao {
                    color: #409eff;
                }

                .icon-qianbao1 {
                    color: #409eff;
                    font-size: 24px;
                }

                .icon-yingshouzhangkuan {
                    font-size: 26px;
                }

                .icon-shishoufeiyong {
                    font-size: 30px;
                }
            }
        }

        .el-form {
            .el-form-item {
                margin-bottom: 0 !important;
            }

            display: flex !important;

            .el-input__prefix {
                line-height: 32px !important;
            }

            .el-form-item__content {
                margin-left: 0 !important;
                line-height: 32px !important;
            }

            .el-date-editor {
                width: 220px !important;
            }

            .el-col-2 {
                width: 30px;
                text-align: center;
                line-height: 32px;
            }

            .el-col-11 {
                width: 220px !important;
                line-height: 32px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/moneyDetail.vue